/**
 * Navigation Slice
 *
 * State and actions for project/folder/list navigation.
 */

import type { StateCreator } from 'zustand';
import type { AppStore, NavigationSlice } from '../types';

export const createNavigationSlice: StateCreator<AppStore, [], [], NavigationSlice> = (set) => ({
  selectedProjectName: '',
  selectedProjectId: undefined,
  selectedFolderName: null,
  selectedFolderId: undefined,
  selectedListName: '',
  selectedListId: undefined,

  setSelectedProject: (name, id) => set({ selectedProjectName: name, selectedProjectId: id }),
  setSelectedFolder: (name, id) => set({ selectedFolderName: name, selectedFolderId: id }),
  setSelectedList: (name, id) => set({ selectedListName: name, selectedListId: id }),

  clearNavigationSelection: () =>
    set({
      selectedProjectName: '',
      selectedProjectId: undefined,
      selectedFolderName: null,
      selectedFolderId: undefined,
      selectedListName: '',
      selectedListId: undefined,
    }),
});
